import { render, staticRenderFns } from "./tigerPromo.vue?vue&type=template&id=7ad23428"
import script from "./tigerPromo.vue?vue&type=script&lang=js"
export * from "./tigerPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports